import React from 'react'
import PropTypes from 'prop-types'
import { Link as LinkRRD } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const style= theme => ({
	link: {
		color: 'inherit',
		textDecoration: 'inherit'
	}
})

function Link({
	children,
	to,
	variant,
	component,
	classes,
	className,
}) {
	return (
		<Typography className={className} component={component} variant={variant} >
			<LinkRRD className={classes.link} to={to}>
				{children}
			</LinkRRD>
		</Typography>
	)
}

Link.propTypes = {
	children: PropTypes.any,
	to: PropTypes.string,
	variant: PropTypes.string,
	component: PropTypes.string,
}

Link.defaultProps = {
	variant: 'body1',
}

export default withStyles(style)(Link);
